
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shelves",
      function () {
        return require("private-next-pages/shelves.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shelves"])
      });
    }
  